/** Virtual column for leads whose stage was deleted. Never stored on the pipeline. */
export const UNASSIGNED_STAGE_ID = -1;
export const UNASSIGNED_STAGE_NAME = 'Unassigned';

export function stageStillExists(stageId: number | null | undefined, stages: { id: number }[]): boolean {
  if (stageId == null) return false;
  return stages.some((stage) => stage.id === stageId);
}

/** Real stages, plus Unassigned at the end when this pipeline has a lead with no stage. */
export function withUnassignedStage<T extends { id: number; name: string }>(
  stages: T[],
  unassignedCount: number,
): T[] {
  if (unassignedCount < 1) return stages;
  return [...stages, { id: UNASSIGNED_STAGE_ID, name: UNASSIGNED_STAGE_NAME } as T];
}
